import { usePromotionTracking } from '../../data-layer/hooks/usePromotionTracking';

export const handleBrazeInAppMessage = (inAppMessage, isControl = false) => {
  const { trackPromotionView, trackPromotionSelect } = usePromotionTracking({
    componentName: 'in_app_message',
    disableThrottling: true,
  });

  trackPromotionView(inAppMessage.analyticsData);

  if (isControl) return;
  inAppMessage.buttons?.forEach((button) => {
    button.subscribeToClickedEvent(() => {
      trackPromotionSelect(inAppMessage.analyticsData);
    });
  });
};
